// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KQtV","productName":"Table_productName__1nQwj"};